module.exports = __WEBPACK_EXTERNAL_MODULE_38__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ResizeSensor","commonjs2":"css-element-queries/src/ResizeSensor.js","commonjs":"css-element-queries/src/ResizeSensor.js","amd":"css-element-queries/src/ResizeSensor.js"}
// module id = 38
// module chunks = 0